module.exports = __webpack_public_path__ + "static/media/btn-play-red.37d5e896.svg";